import React, { Component } from 'react';
import { withAuthorization } from '../Session';

import NavigationApp from '../NavigationApp';
import './styles.css'
import moment from 'moment'
import _, { sampleSize } from 'lodash';
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom';
import OpenSeaDragon from "openseadragon";

import ChannelTab from './components/ChannelTab'

import {CircularProgress} from '@mui/material';

// URL publique Firebase Storage : on encode le path et on ajoute ?alt=media
const STORAGE_BASE = "https://firebasestorage.googleapis.com/v0/b/hyprview-app.appspot.com/o/";

function buildTileUrl(organisationId, sampleId, folder, level, x, y) {
    const path = `${organisationId}/${sampleId}/${folder}/${level}_${x}_${y}.jpg`;
    return STORAGE_BASE + encodeURIComponent(path) + "?alt=media";
}

class SampleDataPage extends Component {
    constructor(props) {
        super(props);

        const sampleId = this.props.match.params.sampleId;
        const groupId = this.props.match.params.groupId;
        const projectId = this.props.match.params.projectId;
        const uid = this.props.firebase.auth.currentUser.uid;

        this.state = {
            organisationId: "",
            viewer: "",
            viewerOpacity: 1,
            loading: true,
            channels: [],
            uid: uid,
            sampleId: sampleId,
            groupId: groupId,
            projectId: projectId,
            brightness: [],
            lut_from: [],
            lut_to: [],
            mean: [],
            min: [],
            max: [],
            histograms: [],
            LUT: [[0, 1], [0, 1], [0, 1]],
            modalitiesName: {},
            histoColor: ['red', 'green', 'blue'],
            activeFolder: 'tiles_HES_fullres',
        };
    }

    componentDidMount() {
        this.props.firebase.Samples().doc(this.state.sampleId).get()
            .then((sample) => {
                document.title = 'Sample - ' + sample.data().name
                let modalityList = []
                for (let i = 0; i < sample.data().modalities.length; i++) {
                    if (sample.data().modalities[i] !== 'GvWA2PST2Zf5kZbFLOYH') {
                        modalityList.push(sample.data().modalities[i]);
                    }
                }
                this.setState({
                    organisationId: sample.data().organisation_id,
                    channels: modalityList,
                },
                () => {
                    let modalitiesName = {...this.state.modalitiesName}
                    sample.data().modalities.map((modalityId) => {
                        if(modalityId != 'GvWA2PST2Zf5kZbFLOYH'){
                            this.props.firebase.Modalities().doc(modalityId).get()
                            .then((modality) => {
                                modalitiesName[modalityId] = modality.data().name
                                this.setState({modalitiesName})
                            })
                        }
                    })
                    this.HandleInitialization(sample)
                })
            })
    }

    async HandleInitialization(sample) {

        // Fonction getTileUrl qui construit l'URL directement (pas de tokens)
        const getTileUrlBound = (level, x, y) => {
            return buildTileUrl(
                this.state.organisationId,
                this.state.sampleId,
                this.state.activeFolder,
                level, x, y
            );
        };

        // Construire les tileSources pour chaque channel
        var tileSources = this.state.channels.map((channel, i) => {
            return {
                tileSource: {
                    height: sample.data().height,
                    width: sample.data().width,
                    tileSize: 500,
                    minLevel: 1,
                    maxLevel: sample.data().max_level,
                    getTileUrl: getTileUrlBound.bind(this),
                    crossOriginPolicy: 'Anonymous',
                },
                opacity: 1,
            };
        });

        // Si aucun channel n'est trouvé, on garde au moins une source par défaut
        if (tileSources.length === 0) {
            tileSources.push({
                tileSource: {
                    height: sample.data().height,
                    width: sample.data().width,
                    tileSize: 500,
                    minLevel: 1,
                    maxLevel: sample.data().max_level,
                    getTileUrl: getTileUrlBound.bind(this),
                    crossOriginPolicy: 'Anonymous',
                },
                opacity: 1,
            });
        }

        var openSD = OpenSeaDragon({
            id: "openSeaDragon",
            prefixUrl: "openseadragon-images/",
            animationTime: 0.25,
            blendTime: 0.1,
            constrainDuringPan: true,
            maxZoomPixelRatio: 6,
            smoothTileEdgesMinZoom: Infinity,
            minZoomLevel: 0,
            visibilityRatio: 1,
            zoomPerScroll: 1.2,
            navigatorPosition: "TOP_LEFT",
            showNavigator: true,
            zoomInButton: "zoom-in",
            zoomOutButton: "zoom-out",
            homeButton: "home",
            fullPageButton: "full-page",
            nextButton: "next",
            previousButton: "previous",
            tileSources: tileSources,
        });

        // Désactiver le lissage pour voir les pixels bruts au zoom max
        openSD.addHandler('tile-drawn', function(event) {
            const canvas = event.eventSource.drawer.canvas;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.imageSmoothingEnabled = false;
                    ctx.mozImageSmoothingEnabled = false;
                    ctx.webkitImageSmoothingEnabled = false;
                    ctx.msImageSmoothingEnabled = false;
                }
            }
        });

        var brightness = [];
        var mean = [];
        var min = [];
        var max = [];
        var histograms = [];

        // Pour chaque channel : récupérer les métadonnées et l'histogramme
        for (var i = 0; i < this.state.channels.length; ++i) {

            var channelInfo = await this.props.firebase.Samples().doc(this.state.sampleId).collection("Acquired_Modalities").doc(this.state.channels[i]).get()
            .then((temp) => {
                return temp.data();
            });

            brightness.push(channelInfo.brightness);
            mean.push(channelInfo.mean);
            min.push(channelInfo.min);
            max.push(channelInfo.max);

            let LUT = [...this.state.LUT]
            LUT[i] = channelInfo.LUT
            this.setState({LUT})

            var histogram_path = await this.props.firebase.Storage().ref(this.state.organisationId + '/' + this.state.sampleId + '/' + this.state.channels[i] + "/histogram.txt").getDownloadURL();
            var histo_values = await fetch(histogram_path).then((r) => { return r.text() }).then((r) => {return r.split("\n")});
            histograms.push(histo_values);
        }

        this.setState({
            viewer: openSD,
            brightness: brightness,
            mean: mean,
            min: min,
            max: max,
            histograms: histograms,
        }, () => {
            this.setState({viewerOpacity: 1, loading: false})
        });
    }

    updateLUTValueInDB(i, values) {
        this.props.firebase.Samples().doc(this.state.sampleId).collection("Acquired_Modalities").doc(this.state.channels[i]).update('LUT', values);
    }

    setActiveFolder(folderName) {
        if (this.state.activeFolder === folderName) return;
        
        this.setState({ activeFolder: folderName }, () => {
            if (this.state.viewer) {
                const world = this.state.viewer.world;
                
                const currentZoom = this.state.viewer.viewport.getZoom();
                const currentCenter = this.state.viewer.viewport.getCenter();
                
                const firstItem = world.getItemAt(0);
                const imgHeight = firstItem ? firstItem.source.dimensions.y : null;
                const imgWidth = firstItem ? firstItem.source.dimensions.x : null;
                const maxLevel = firstItem ? firstItem.source.maxLevel : null;
                
                world.removeAll();
                
                const getTileUrlBound = (level, x, y) => {
                    return buildTileUrl(
                        this.state.organisationId,
                        this.state.sampleId,
                        this.state.activeFolder,
                        level, x, y
                    );
                };
                
                if (this.state.channels && this.state.channels.length > 0) {
                    this.state.channels.forEach((channel, i) => {
                        this.state.viewer.addTiledImage({
                            tileSource: {
                                height: imgHeight,
                                width: imgWidth,
                                tileSize: 500,
                                minLevel: 1,
                                maxLevel: maxLevel,
                                getTileUrl: getTileUrlBound.bind(this),
                                crossOriginPolicy: 'Anonymous',
                            },
                            opacity: 1,
                            success: (event) => {
                                if (i === 0) {
                                    this.state.viewer.viewport.zoomTo(currentZoom, null, true);
                                    this.state.viewer.viewport.panTo(currentCenter, true);
                                }
                            }
                        });
                    });
                } else {
                    this.state.viewer.addTiledImage({
                        tileSource: {
                            height: imgHeight,
                            width: imgWidth,
                            tileSize: 500,
                            minLevel: 1,
                            maxLevel: maxLevel,
                            getTileUrl: getTileUrlBound.bind(this),
                            crossOriginPolicy: 'Anonymous',
                        },
                        opacity: 1,
                        success: () => {
                            this.state.viewer.viewport.zoomTo(currentZoom, null, true);
                            this.state.viewer.viewport.panTo(currentCenter, true);
                        }
                    });
                }
            }
        });
    }

    updateChannelOpacity(i, opacity) {
        if (this.state.viewer && this.state.viewer.tiledImageCount > i) {
            this.state.viewer.tiledImageAt(i).setOpacity(opacity);
        }
    }

    disableChannel(i, state) {
        this.updateChannelOpacity(i, state ? 1 : 0);
    }

    render() {
        return (
            <div id='sample-data-page'>
                {this.state.loading &&
                <div className="loader-container">
                    <CircularProgress/>
                </div>
                }
                <div id='sample-data-container' >
                    <div id='map-container' style={{ backgroundColor: 'black' }}>
                        <div style={{ opacity: this.state.viewerOpacity }} id="openSeaDragon" />
                        
                        {!this.state.loading && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '20px',
                                    zIndex: 1000,
                                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                                    padding: '16px',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                                }}
                            >
                                <div style={{ color: 'white', fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
                                    Modality
                                </div>
                                
                                {[
                                    { key: 'tiles_HES_fullres', label: 'HES' },
                                    { key: 'tiles_multiFluo_fullres', label: 'Multispectral visible fluorescence' },
                                    { key: 'tiles_epi280_fullres', label: 'Deep ultraviolet fluorescence' },
                                    { key: 'tiles_trans265_fullres', label: 'Deep ultraviolet absorbance' },
                                    { key: 'tiles_trans375_fullres', label: 'Ultraviolet scattering' },
                                    { key: 'tiles_trans530_fullresbis', label: 'Visible light scattering' },
                                ].map((folder, idx, arr) => (
                                    <label key={folder.key} style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        color: 'white', 
                                        cursor: 'pointer',
                                        marginBottom: idx < arr.length - 1 ? '8px' : '0px',
                                        fontSize: '13px'
                                    }}>
                                        <input
                                            type="radio"
                                            name="folder"
                                            value={folder.key}
                                            checked={this.state.activeFolder === folder.key}
                                            onChange={() => this.setActiveFolder(folder.key)}
                                            style={{ marginRight: '8px', cursor: 'pointer' }}
                                        />
                                        {folder.label}
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* <div id="tabUI">
                    {this.state.channels.map((channel, i) => {
                        return (
                            <ChannelTab
                                key={channel}
                                values={this.state.LUT[i]}
                                modalityName={this.state.modalitiesName[channel]}
                                histoColor={this.state.histoColor[i]}
                                updateChannelValue={(e, values) => { this.updateLUTValueInDB(i, values) }}
                                updateLUTValueInDB={(e, values) => { this.updateLUTValueInDB(i, values) }}
                                disableChannel={(state) => this.disableChannel(i, state)}
                                histogramData={this.state.histograms[i]}
                            />
                        )
                    })
                    }
                </div> */}
            </div>
        )
    }
};

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(SampleDataPage);